import { graphql } from "../gql";

export const getProvidersQueryDoc = graphql(`
  query getProviders($orderBy: [ProvidersOrderBy!]) {
    providers(orderBy: $orderBy) {
      nodes {
        ...ProviderFragment
      }
    }
  }
`);
